import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(879);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 879);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <div className="sticky top-0 z-50 w-full bg-[#22c55e] text-white py-0.5 text-center font-semibold text-xs shadow-sm" data-id="element-1">
      <div className="flex items-center justify-center gap-1.5" data-id="element-2">
        <span data-id="element-3">Oferta termina en:</span>
        <span className="bg-white/20 px-1.5 py-px rounded font-mono text-xs tracking-wider" data-id="element-4">
          {formatTime(timeLeft)}
        </span>
      </div>
    </div>;
}